import { useQuery } from 'react-query';
import { noop } from 'lodash';

const CACHE_TIME = 30 * 1000;

export const usePickerTotal = ({ fetcher, enabled, queryKey }) => {
    const { isSuccess, data } = useQuery(
        queryKey,
        async () => {
            let total;
            const onSuccess = (_, __, newTotal) => {
                total = newTotal;
            };
            await fetcher({
                searchText: '',
                pageSize: 1,
                isRetry: false,
                onSuccess,
                onError: noop,
                options: [],
                singleRequestCacheKey: queryKey,
            });

            return total;
        },
        { enabled, cacheTime: CACHE_TIME, staleTime: CACHE_TIME }
    );
    const total = enabled && isSuccess ? data : null;

    return total;
};
